import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [erro, setErro] = useState("");
  const navigate = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setErro("");

    try {
      const response = await axios.post("/api/auth/login", {
        email,
        password,
      });

      const accessToken = response.data.access_token;
      localStorage.setItem("token", accessToken);

      // Extrair payload do JWT
      const payload = jwtDecode(accessToken);

      // Guardar role no frontend
      localStorage.setItem("role", payload.role);

      navigate("/projetos");
    } catch (err) {
      setErro("Credenciais inválidas");
    }
  }

  return (
    <div style={{ padding: "30px" }}>
      <h2>Login</h2>

      <form onSubmit={submit}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        /><br /><br />

        <input
          type="password"
          placeholder="Senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        /><br /><br />

        <button type="submit">Entrar</button>

        {erro && <p style={{ color: "red" }}>{erro}</p>}
      </form>
    </div>
  );
}
